/**
 * Maintain available Themes here
 */
export const THEMES = {
  BASE_DARK_HIGH_CONTRAST: 'base-dark-high-contrast',
  BASE_DARK: 'base-dark',
  BASE_LIGHT_HIGH_CONTRAST: 'base-light-high-contrast',
  BASE_LIGHT: 'base-light',
  LEGACY: 'legacy',
} as const;
